import React from "react";
import FloatingComponents from "../../components/floatingComponents/FloatingComponents";
import { useSelector } from "react-redux";
import ErrorBoundary from "../../helpers/ExceptionHandler/componentException";
import PromotionRewardInner from "../../components/user-pages/promotion-reward/PromotionRewardInner";

const PromotionReward = () => {
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));
  return (
    <>
      <ErrorBoundary>
        <PromotionRewardInner />
      </ErrorBoundary>
      {typeof componentSetting.floatingComponents != "undefined" &&
        componentSetting.floatingComponents.defaultValue ===
        "right_vertical" && <ErrorBoundary><FloatingComponents /></ErrorBoundary>}
    </>
  );
};

export default PromotionReward;
